var _path, _path2, _path3, _path4, _path5, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateSurveys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 232,
    viewBox: "0 0 208 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.806 76H42V87.1229H138.806V76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.806 106.6H42V117.723H138.806V106.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.806 137.2H42V148.323H138.806V137.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.806 167.553H42.4062V178.683H90.806V167.553Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.484 39.8537C175.777 35.8182 172.938 32.4052 169.363 29.9842C165.787 27.5699 161.433 26.1467 156.803 26.1467H137.474V22.8121H109.458C109.586 21.9059 109.657 20.9711 109.657 20.0295C109.656 8.98456 100.672 0 89.6268 0C78.5818 0 69.5973 8.98456 69.5973 20.0295C69.5973 20.9711 69.668 21.9059 69.7957 22.8121H41.7799V26.1467H22.451C19.3711 26.1467 16.3977 26.777 13.7143 27.9166C9.6715 29.623 6.25901 32.4619 3.83751 36.0375C1.42326 39.6199 0 43.9672 0 48.5977V209.556C0 212.636 0.630298 215.603 1.76311 218.293C3.47638 222.329 6.31566 225.741 9.89126 228.162C13.4669 230.584 17.8205 232 22.451 232H156.803L179.254 135V48.5977C179.254 45.511 178.623 42.5444 177.484 39.8537ZM89.6268 12.5955C93.7262 12.5955 97.0607 15.9301 97.0607 20.0295C97.0607 21.0137 96.8623 21.948 96.5084 22.8121H82.7375C82.3904 21.9485 82.1923 21.0137 82.1923 20.0295C82.1928 15.9301 85.5346 12.5955 89.6268 12.5955ZM156.803 218.647H22.451C21.1763 218.647 19.9941 218.392 18.9107 217.939C17.2894 217.252 15.8875 216.084 14.9033 214.632C13.9191 213.174 13.3527 211.46 13.3527 209.556V48.5977C13.3527 47.323 13.6078 46.1408 14.0677 45.0574C14.7547 43.4289 15.9088 42.0341 17.3669 41.05C18.8255 40.073 20.5388 39.5066 22.4505 39.4994H41.779V42.282C41.779 47.507 46.013 51.741 51.2453 51.741H128.007C133.24 51.741 137.474 47.507 137.474 42.282V39.4994H156.802C158.077 39.4994 159.259 39.7545 160.342 40.2144C161.964 40.9013 163.366 42.0554 164.35 43.5136C165.327 44.979 165.893 46.6855 165.9 48.5972V88.837V135H179.254L156.803 232V218.647Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 167.935,
    y: 148,
    width: 11.13,
    height: 69
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 188.065,
    width: 11.13,
    height: 69,
    transform: "rotate(-90 139 188.065)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateSurveys);
export default __webpack_public_path__ + "static/media/create-surveys.bc4e9c9ebce0f3065fce058e36d816a7.svg";
export { ForwardRef as ReactComponent };